import axios from "axios";
import API_BASE from "../config";
import authHeader from "./auth-header";

const API_URL = API_BASE + "/api/auth/";

// Admin-only: creating a user requires a signed-in admin's token.
const register = (username, email, password, roles, repeatPassword) => {
  return axios.post(
    API_URL + "signup",
    {
      username,
      email,
      password,
      ...(repeatPassword !== undefined ? { repeatPassword } : {}),
      ...(roles && roles.length ? { roles } : {}),
    },
    { headers: authHeader() }
  );
};

const login = (username, password) => {
  return axios
    .post(API_URL + "signin", {
      username,
      password,
    })
    .then((response) => {
      if (response.data.accessToken) {
        localStorage.setItem("user", JSON.stringify(response.data));
      }

      return response.data;
    });
};

// Login or register using a Google ID token (credential from Google Identity Services).
const googleLogin = (credential) => {
  return axios.post(API_URL + "google", { credential }).then((response) => {
    if (response.data.accessToken) {
      localStorage.setItem("user", JSON.stringify(response.data));
    }
    return response.data;
  });
};

const changePassword = (currentPassword, newPassword, confirmPassword) => {
  return axios.put(
    API_URL + "password",
    { currentPassword, newPassword, confirmPassword },
    { headers: authHeader() }
  );
};

const logout = () => {
  localStorage.removeItem("user");
  // Stop Google from auto-signing the user back in.
  if (window.google && window.google.accounts && window.google.accounts.id) {
    window.google.accounts.id.disableAutoSelect();
  }
};

// Decode the JWT payload and check its `exp` claim (seconds since epoch).
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const payload = JSON.parse(atob(base64));
    return !payload.exp || payload.exp * 1000 <= Date.now();
  } catch (e) {
    return true;
  }
};

// Returns the stored user, or null if missing/expired (and clears stale data).
const getCurrentUser = () => {
  let user = null;
  try {
    user = JSON.parse(localStorage.getItem("user"));
  } catch (e) {
    user = null;
  }
  if (user && isTokenExpired(user.accessToken)) {
    localStorage.removeItem("user");
    return null;
  }
  return user;
};

const AuthService = {
  register,
  login,
  googleLogin,
  logout,
  changePassword,
  getCurrentUser,
  isTokenExpired,
};

export default AuthService;